export class NotFoundError extends Error {
    public static readonly statusCode = 404;

    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, NotFoundError.prototype);
    }
}